<template>
    <div class="imported-blocks">
        <div class="blocks-list">
            <div class="block-item" v-for="importRecord in blocks" :key="importRecord._id">
                <div class="block-info">
                    <span class="material-icons block-icon">{{ $_.get(importRecord, 'block.icon', 'extension') }}</span>
                    <div class="block-details">
                        <h3>{{ importRecord.customName || $_.get(importRecord, 'block.name', 'Bilinmeyen Blok') }}</h3>
                        <p>{{ $_.get(importRecord, 'block.description', 'Bilinmeyen Blok') }}</p>
                        <div class="block-meta">
                            <span class="import-date">
                                {{ $t("chatbotv2.imported") || "Imported" }}:
                                {{ formatDate(importRecord.importedAt) }}
                            </span>
                            <a-tag v-if="!importRecord.versionId" color="blue">
                                {{ $t("chatbotv2.latest") || "Latest" }}
                            </a-tag>
                            <a-tag v-else color="default">
                                {{ $t("chatbotv2.pinned") || "Pinned" }}
                            </a-tag>
                        </div>
                    </div>
                </div>

                <div class="block-actions">
                    <a-button size="small" @click="viewDetails(importRecord.blockId)">
                        <a-icon type="eye" />
                        {{ $t("chatbotv2.viewDetails") || "Details" }}
                    </a-button>
                    <a-popconfirm
                        :title="$t('chatbotv2.confirmRemoveImport') || 'Are you sure you want to remove this import?'"
                        @confirm="removeImport(importRecord.blockId)"
                    >
                        <a-button size="small" type="danger">
                            <a-icon type="delete" />
                            {{ $t("chatbotv2.remove") || "Remove" }}
                        </a-button>
                    </a-popconfirm>
                </div>
            </div>
        </div>

        <div class="empty-state" v-if="blocks.length === 0">
            <a-empty :description="$t('chatbotv2.noImportedBlocks') || 'No imported blocks'" />
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";

export default {
    name: "ImportedBlocks",
    computed: {
        ...mapState({
            blocks: (state) => state.customBlocks.importedBlocks,
        }),
    },
    methods: {
        ...mapActions({
            removeImportAction: "customBlocks/removeImport",
            listImportedBlocks: "customBlocks/listImportedBlocks",
        }),
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY");
        },
        viewDetails(blockId) {
            this.$emit("view-details", blockId);
        },
        async removeImport(blockId) {
            try {
                await this.removeImportAction(blockId);
                this.$message.success(this.$t("chatbotv2.importRemoved") || "Import removed successfully");
            } catch (error) {
                this.$message.error(error.message || "Failed to remove import");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.imported-blocks {
    .blocks-list {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .block-item {
            background: #fff;
            border: 1px solid #e0e0e0;
            border-radius: 8px;
            padding: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .block-info {
                display: flex;
                gap: 16px;
                flex: 1;

                .block-icon {
                    font-size: 48px;
                    color: #9c27b0;
                }

                .block-details {
                    flex: 1;

                    h3 {
                        margin: 0 0 8px 0;
                        font-size: 18px;
                    }

                    p {
                        margin: 0 0 12px 0;
                        color: #666;
                        font-size: 14px;
                    }

                    .block-meta {
                        display: flex;
                        gap: 12px;
                        align-items: center;

                        .import-date {
                            font-size: 13px;
                            color: #999;
                        }
                    }
                }
            }

            .block-actions {
                display: flex;
                gap: 8px;
            }
        }
    }

    .empty-state {
        min-height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>

